export default __webpack_public_path__ + "static/media/char_head_prem_008.bc54178f.png";